import { configureStore } from "@reduxjs/toolkit" //redux store'u oluşturduğum fonksiyon
import checkedReducer from "./checkedSlice"; //Uygulamanın durumunu yöneten reducerlar
import sessionReducer from "./sessionSlice";

export const store = configureStore({
    reducer: { //Store'un durumunu yöneten reducer'ları içerir
        checked: checkedReducer,
        session: sessionReducer
    },
});

export default store;


//Bu sayfada redux store'u oluşturdum ve configureStore ile store'yi yapılandırdım 
// checkedSlice ve sessionSlice reducerlarını içeren reucer nesnesi oluşturdum
//redux store uygulamanın tüm statelerini içeren bir vt gibi davranır
//Store yani depo: Uygulamanın durumunu saklayan merkezi bir depodur ve uygulama durumunu tke bir nesne olarak tanımlar


// useSelector: Redux store'dan belirli bir durumu seçmeyi sağlar.
// useDispatch: Redux store'a action göndermeyi sağlar.